import { topliApi } from '@/shared/api/topli/TopliApi'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { residentialsByPageQueryKey } from '@/entities/Residential'
import { PhotoOwner } from '@/entities/Photos'

export const deleteResidential = async (companyId: number) => {
  const response = await topliApi.residential.delete(companyId)
  return response
}

export const useDeleteResidentialApi = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => deleteResidential(id),
    onSuccess: (_res, id) => {
      topliApi.photo.deleteAllPhotos({ id, owner_id: PhotoOwner.Residential })

      queryClient.invalidateQueries({
        queryKey: [residentialsByPageQueryKey],
        refetchType: 'active',
      })
    },
  })
}
